<template>
  <div>
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
  <div class="animated fadeIn">
    <ValidationObserver ref="observer" v-slot="{ invalid, validate }">
      <b-row>
        <b-col>
          <transition name="fade">
            <b-card
              border-variant="info"
         
            >
              <div slot="header">
                <span data-font="22" class="mt-2">Create Template</span>
                <div class="card-header-actions">
                  <eb-button
                    class="mr-1 btn-primary"
                    text="Back"
                    @click="$router.push('/notification-template')"
                  ></eb-button>
                </div>
              </div>
              <div>
                <b-row>
                  <b-col md="6">
                    <label class="label">Concern *</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Concern"
                    >
                      <eb-select
                        type="text"
                        label="text"
                        placeholder="Select Concern"
                        :options="concernOptions"
                        v-model="selectedOption"
                        :selected="selectedOption.text"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>

                <h4 class="pt-2 m-2">Select Template Type</h4>
                <b-form-radio-group
                  class="ml-2"
                  id="radio-group-2"
                  v-model="selectedTemplateOption"
                  name="radio-sub-component"
                >
                  <b-form-radio value="email" name="radio-size" size="lg">
                    <p class="delivery-radio-align">Email</p>
                  </b-form-radio>
                  <b-form-radio value="sms" name="radio-size" size="lg">
                    <p class="delivery-radio-align">SMS</p>
                  </b-form-radio>
                  <b-form-radio value="whatsapp" name="radio-size" size="lg">
                    <p class="delivery-radio-align">Whatsapp</p>
                  </b-form-radio>
                  <b-form-radio value="inapp" name="radio-size" size="lg">
                    <p class="delivery-radio-align">Inapp</p>
                  </b-form-radio>
                </b-form-radio-group>

                <b-row v-if="selectedTemplateOption == 'email'">
                  <b-col>
                    <h4 class="pt-2 m-2">Email Template</h4>
                    <div class="form-group">
                      <label class="label">Subject *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Subject"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="Subject"
                          class="form-control w-95"
                          v-model="subject"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'email'">
                  <b-col>
                    <div class="form-group">
                      <label class="label">Body *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Body"
                      >
                        <textarea
                          maxlength="1000"
                          type="text"
                          rows="4"
                          placeholder="HTML (text Area)"
                          class="form-control w-95"
                          v-model="htmlEmailText"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'email'">
                  <b-col>
                    <div class="form-group">
                      <label class="label">CSS (Optional)</label>

                      <textarea
                        maxlength="1000"
                        type="text"
                        rows="4"
                        placeholder="CSS (text Area)"
                        class="form-control w-95"
                        v-model="cssText"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'email'">
                  <b-col md="6">
                    <div class="form-group">
                      <label class="label">From Name *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="From Name"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="From Name"
                          class="form-control w-95"
                          v-model="fromName"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <label class="label">From Email *</label>
                      <ValidationProvider
                        rules="required|email"
                        v-slot="{ errors }"
                        name="From Email"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="From Email"
                          class="form-control w-95"
                          v-model="fromEmail"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'sms'">
                  <b-col>
                    <h4 class="pt-2 m-2">SMS Template</h4>
                    <div class="form-group">
                      <label class="label">Body *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Body"
                      >
                        <textarea
                          maxlength="1000"
                          rows="4"
                          type="text"
                          placeholder="HTML (text Area)"
                          class="form-control w-95"
                          v-model="htmlSmsText"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'sms'">
                  <b-col>
                    <div class="form-group">
                      <label class="label">Template Id *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Template Id"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="Template ID"
                          class="form-control w-95"
                          v-model="templateId"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'whatsapp'">
                  <b-col md="12" class="pb-2 mt-3">
                    <h4>Whatsapp Template</h4>
                  </b-col>
                  <b-col md="6" class="pt-0">
                    <div class="form-group">
                      <label class="label">Header (Optional)</label>
                      <h5 style="margin-top: 0px">
                        Add a title or choose which type of media you'll use for
                        this header.
                      </h5>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Whatsapp"
                      >
                        <eb-select
                          type="text"
                          label="text"
                          placeholder="Select Header"
                          :options="headerOptions"
                          v-model="selectedHeaderOption"
                          :selected="selectedHeaderOption.text"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="row">
                      <b-col class="">
                        <div class="form-group">
                          <b-form-file
                            v-if="selectedHeaderOption.value == 'image'"
                            placeholder="Upload File"
                            drop-placeholder="Drop file here..."
                            v-model="attachment"
                            accept="image/*"
                            :state="Boolean(attachment)"
                            @change="readFile"
                          >
                          </b-form-file>
                        </div>
                        <div class="form-group">
                          <b-form-file
                            v-if="selectedHeaderOption.value == 'document'"
                            placeholder="Upload File"
                            drop-placeholder="Drop file here..."
                            v-model="attachment"
                            accept="document/*"
                            :state="Boolean(attachment)"
                            @change="readFile"
                          >
                          </b-form-file>
                        </div>
                        <div class="form-group">
                          <b-form-file
                            v-if="selectedHeaderOption.value == 'video'"
                            placeholder="Upload File"
                            drop-placeholder="Drop file here..."
                            v-model="attachment"
                            accept="video/*"
                            :state="Boolean(attachment)"
                            @change="readFile"
                          >
                          </b-form-file>
                        </div>
                        <div class="form-group">
                          <b-form-input
                            v-if="selectedHeaderOption.value == 'text'"
                            placeholder="Enter Title"
                            v-model="headerText"
                          >
                          </b-form-input>
                        </div>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col md="6" class="pt-0">
                    <label class="label">Body *</label>
                    <h5 style="margin-top: 0px">
                      Enter the text for your message.
                    </h5>
                    <div
                      class="row"
                      v-for="(bodyTxt, index) in bodyText"
                      :key="`textBody-${index}`"
                    >
                      <b-col md="9">
                        <div class="form-group">
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Body Text"
                          >
                            <b-form-input
                              type="text"
                              label="text"
                              placeholder="Enter Body Text"
                              v-model="bodyTxt.text"
                            ></b-form-input>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          @click="addBodyText(bodyTxt, bodyText)"
                          variant="success"
                          class="circularBtn"
                        >
                          <span>
                            <i class="fa fa-plus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                      <b-col md="1">
                        <b-button
                          v-show="bodyText.length > 1"
                          @click="removeBodyText(index, bodyText)"
                          variant="danger"
                          class="circularBtn"
                        >
                          <span>
                            <i class="fa fa-minus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <label class="label">Template Id *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Whatsapp Template ID"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="Enter Template ID"
                          class="form-control w-95"
                          v-model="templateIdWhatsapp"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'inapp'">
                  <b-col md="12">
                    <h4 class="pt-2 m-2">Inapp Template</h4>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <label class="label">Subject *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Subject"
                      >
                        <input
                          maxlength="100"
                          type="text"
                          placeholder="Subject"
                          class="form-control w-95"
                          v-model="subject"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="6" style="margin-top: 31px">
                    <div class="form-group">
                      <b-form-file
                        placeholder="Upload Title Image"
                        drop-placeholder="Drop file here..."
                        v-model="attachment"
                        accept="image/*"
                        :state="Boolean(attachment)"
                        @change="readFile"
                      >
                      </b-form-file>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="selectedTemplateOption == 'inapp'">
                  <b-col>
                    <div class="form-group">
                      <label class="label">Body *</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Body"
                      >
                        <textarea
                          maxlength="1000"
                          rows="4"
                          type="text"
                          placeholder="Message"
                          class="form-control w-95"
                          v-model="htmlInappText"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                </b-row>
                <div class="text-center mt-3">
                  <button
                    type="submit"
                    @click="submitCreateTemplate"
                    class="btn btn-primary"
                    :disabled="invalid"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </ValidationObserver>
  </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import cInput from "@/components/Common/CustomInput";
import { AtomSpinner } from "epic-spinners";
import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
export default {
  name: "CreateTemplate",
  components: {
    ebSelect,
    ebButton,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
    cInput,
  },

  data() {
    return {
      selectedTemplateOption: "email",
      concern: "",
      subject: "",
      htmlEmailText: "",
      cssText: "",
      loading:false,
      htmlSmsText: "",
      htmlWhatsappText: "",
      htmlInappText: "",
      fromName: "",
      fromEmail: "",
      selectedOption: [],
      templateId: "",
      templateIdWhatsapp: "",
      selectedHeaderOption: "",
      headerOptions: [
        {
          text: "Document",
          value: "document",
        },
        {
          text: "Image",
          value: "image",
        },
        {
          text: "Video",
          value: "video",
        },
        {
          text: "Title",
          value: "text",
        },
      ],
      bodyText: [{ type: "text", text: "" }],
      attachment: "",
      attachmentName: "",
      headerText: "",
    };
  },
  computed: {
    ...mapGetters({
      getConcernOptionData: "emailTemplate/GetconcernOptionData",
    }),
    concernOptions() {
      const optionSelected = this.getConcernOptionData.map((option) => {
        return option.name;
      });
      return optionSelected;
    },
  },
  methods: {
    async submitCreateTemplate() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      if (this.selectedOption) {
        let concernType = this.getConcernOptionData.find(
          (concernName) => concernName.name == this.selectedOption
        );
        if (typeof this.attachment !== "string") this.attachment = "";
        if (
          this.selectedTemplateOption == "email" &&
          this.htmlEmailText &&
          this.subject &&
          this.fromEmail &&
          this.fromName
        ) {
          let payload = {
            concern: this.selectedOption,
            type: concernType?.type || "",
            email: {
              body: this.htmlEmailText,
              from: {
                email: this.fromEmail,
                name: this.fromName,
              },
              subject: this.subject,
              css: this.cssText || "",
              active: true,
            },
          };
          await this.$store
            .dispatch("emailTemplate/createEmailTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              let errMessage = "Unable to Create Template";
              if (err.includes("concern")) errMessage = "Duplicate Concern";
              this.$swal({
                title: "Sorry",
                text: errMessage,
                type: "error",
              });
            });
        }
        if (this.selectedTemplateOption == "sms" && this.htmlSmsText) {
          let payload = {
            concern: this.selectedOption,
            type: concernType?.type || "",
            sms: {
              templateId: this.templateId,
              body: this.htmlSmsText,
              active: true,
            },
          };
          await this.$store
            .dispatch("smsTemplate/createSmsTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              let errMessage = "Unable to Create Template";
              if (err.includes("concern")) errMessage = "Duplicate Concern";
              this.$swal({
                title: "Sorry",
                text: errMessage,
                type: "error",
              });
            });
        }
        if (this.selectedTemplateOption == "whatsapp") {
          let headerParameter = [];
          let bodyParameter = [];
          let whatsappPayload;
          if (this.selectedHeaderOption.value == "text") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              text: this.headerText,
            });
          } else if (this.selectedHeaderOption.value == "document") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              document: {
                link: this.attachment,
                filename: this.attachmentName,
              },
            });
          } else if (this.selectedHeaderOption.value == "image") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              image: { link: this.attachment },
            });
          } else if (this.selectedHeaderOption.value == "video") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              video: { link: this.attachment },
            });
          }
          this.bodyText.map((oneText) =>
            bodyParameter.push({
              type: "text",
              text: oneText.text,
            })
          );

          if (this.bodyText[0].text == "" && this.selectedHeaderOption == "") {
            let payload = {
              concern: this.selectedOption,
              type: concernType?.type || "",
              serviceName: "batch",
              whatsapp: {
                templateId: this.templateIdWhatsapp,
                components: [],
                active: true,
              },
            };
            whatsappPayload = payload;
          } else if (
            this.bodyText[0].text != "" &&
            this.selectedHeaderOption == ""
          ) {
            let payload = {
              concern: this.selectedOption,
              type: concernType?.type || "",
              serviceName: "batch",
              whatsapp: {
                templateId: this.templateIdWhatsapp,
                components: [
                  {
                    type: "body",
                    parameters: bodyParameter,
                  },
                ],
                active: true,
              },
            };
            whatsappPayload = payload;
          } else if (
            this.bodyText[0].text == "" &&
            this.selectedHeaderOption != ""
          ) {
            let payload = {
              concern: this.selectedOption,
              type: concernType?.type || "",
              serviceName: "batch",
              whatsapp: {
                templateId: this.templateIdWhatsapp,
                components: [
                  {
                    type: "header",
                    parameters: headerParameter,
                  },
                ],
                active: true,
              },
            };
            whatsappPayload = payload;
          } else {
            let payload = {
              concern: this.selectedOption,
              type: concernType?.type || "",
              serviceName: "batch",
              whatsapp: {
                templateId: this.templateIdWhatsapp,
                components: [
                  {
                    type: "header",
                    parameters: headerParameter,
                  },
                  {
                    type: "body",
                    parameters: bodyParameter,
                  },
                ],
                active: true,
              },
            };
            whatsappPayload = payload;
          }
          const resp = await this.$store
            .dispatch(
              "whatsappTemplate/createWhatsappTemplate",
              whatsappPayload
            )
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              let errMessage = "Unable to Create Template";
              if (err.includes("concern")) errMessage = "Duplicate Concern";
              this.$swal({
                title: "Sorry",
                text: errMessage,
                type: "error",
              });
            });
        }
        if (
          this.selectedTemplateOption == "inapp" &&
          this.htmlInappText &&
          this.subject
        ) {
          let payload = {
            concern: this.selectedOption,
            type: concernType?.type || "",
            inapp: {
              subject: this.subject,
              body: this.htmlInappText,
              image: {
                link: this.attachment,
              },
              active: true,
            },
          };
          await this.$store
            .dispatch("inappTemplate/createInappTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              let errMessage = "Unable to Create Template";
              if (err.includes("concern")) errMessage = "Duplicate Concern";
              this.$swal({
                title: "Sorry",
                text: errMessage,
                type: "error",
              });
            });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
      this.attachment = "";
    },

    addBodyText(value, textType) {
      textType.push({ value: "" });
    },
    removeBodyText(index, textType) {
      textType.splice(index, 1);
    },
    readFile(e) {
      if (
        (this.selectedHeaderOption.value == "image" &&
          !e.target.files[0].type.match("image.*")) ||
        (this.selectedHeaderOption.value == "video" &&
          !e.target.files[0].type.match("video.*"))
      ) {
        this.invalid = true;
        this.$toasted.error("Invalid File format");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      this.attachmentName = e.target.files[0].name;
      reader.onload = () => {
        this.uploadFile(reader.result);
      };
      reader.onerror = (err) => {
        this.$toasted.error("Image not uploaded..please try again!");
      };
    },
    async uploadFile(file) {
      let dataobj = {
        image: file,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.attachment = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
          this.loading = false;
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch("emailTemplate/fetchConcernList");
    this.loading = false;
  },
};
</script>
<style>
.label {
  background-color: #ffff;
  font-family: "Lato";
  font-weight: bold;
}

.form-control {
  height: calc(2.2125rem + 8px);
}

.circularBtn {
  height: 40px;
  width: 40px;
  border-radius: 100%;
  text-align: center;
}
.mt-2, .my-2 {
  margin-top: 0.75rem !important;
  font-weight: bold;
}
</style>
